import {FC, PropsWithChildren} from "react";
import Context from "./employeesContext";
import useEmployees from "hooks/useEmployees";

const EmployeesProvider: FC<PropsWithChildren> = ({children}) => {
  const out = useEmployees();

  return <Context.Provider value={out}>{children}</Context.Provider>;
};

export default EmployeesProvider;
